import {getaccess_token} from "../store/reducer/authentication";

export const generateAuthHeaders = (state$) => {
    const access_token = getaccess_token(state$.value.authentication);
    return {'Authorization': `Bearer ${access_token}`, 'Content-Type' : 'application/json'}
};